/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime';

class GoogleSchedule extends React.Component {
    constructor(props) {
        super(props);

        this.updateTime = this.updateTime.bind(this);

    }

    updateTime(newTime, which) {
        let isTime = (['startTime', 'endTime'].indexOf(which) !== -1) ? true : false,
            dateObj = this.props.convertDateToObject(newTime, isTime),
            inputEvent = {
                currentTarget: {
                    dataset: {
                        field: `postData.services.${this.props.serviceType}.schedule.${which}`
                    }
                },
                target: {
                    value: dateObj
                }
            };

        this.props.requestChange(inputEvent);

    }

    render() {
        let startDate = null,
            startTime = null,
            endDate = null,
            endTime = null,
            postData = this.props.postData,
            startDateHasError = false,
            endDateHasError = false;

        if (postData.schedule !== undefined) {
            if (postData.schedule.startDate !== undefined) {
                startDate = this.props.convertObjectToDate(postData.schedule.startDate, false, this.props.user.detail.timezone);
            }
            if (postData.schedule.startTime !== undefined) {
                startTime = this.props.convertObjectToDate(postData.schedule.startTime, true, this.props.user.detail.timezone);
            }
            if (postData.schedule.endDate !== undefined) {
                endDate = this.props.convertObjectToDate(postData.schedule.endDate, false, this.props.user.detail.timezone);
            }
            if (postData.schedule.endTime !== undefined) {
                endTime = this.props.convertObjectToDate(postData.schedule.endTime, true, this.props.user.detail.timezone);
            }
        }

        let groupLabel = 'Event Date';

        if (postData.form === 'OFFER') {
            groupLabel = 'Offer Date';
        }

        if (this.props.validationErrors[this.props.serviceType] !== undefined && this.props.validationErrors[this.props.serviceType].startDate !== undefined) {
            startDateHasError = true;
        }

        if (this.props.validationErrors[this.props.serviceType] !== undefined && this.props.validationErrors[this.props.serviceType].endDate !== undefined) {
            endDateHasError = true;
        }

        return (
            <div>
                <div className="pt-field-label">{groupLabel}</div>
                <div className="pt-schedule-row gb-start">
                    <DateTimePicker
                        inputProps={{
                            placeholder: "Start Date",
                            className: `text-input ${(startDateHasError) ? 'error' : ''}`
                        }}
                        timeFormat={false}
                        onChange={(newTime) => {
                            this.updateTime(newTime, 'startDate');
                        }}
                        closeOnSelect={true}
                        value={startDate}
                        displayTimeZone={this.props.user.detail.timezone}/>
                    <DateTimePicker
                        inputProps={{
                            placeholder:"Start Time (optional)",
                            className: 'text-input'
                        }}
                        dateFormat={false}
                        onChange={(newTime) => {
                            this.updateTime(newTime, 'startTime');
                        }}
                        closeOnSelect={true}
                        value={startTime}
                        displayTimeZone={this.props.user.detail.timezone}/>
                </div>
                <div className="pt-schedule-row gb-end">
                    <DateTimePicker
                        inputProps={{
                            placeholder:"End Date",
                            className: `text-input ${(endDateHasError) ? 'error' : ''}`
                        }}
                        timeFormat={false}
                        onChange={(newTime) => {
                            this.updateTime(newTime, 'endDate');
                        }}
                        closeOnSelect={true}
                        value={endDate}
                        displayTimeZone={this.props.user.detail.timezone}/>
                    <DateTimePicker
                        inputProps={{
                            placeholder:"End Time (optional)",
                            className: 'text-input'
                        }}
                        dateFormat={false}
                        onChange={(newTime) => {
                            this.updateTime(newTime, 'endTime');
                        }}
                        closeOnSelect={true}
                        value={endTime}
                        displayTimeZone={this.props.user.detail.timezone}/>
                </div>
            </div>
        );
    }
}

GoogleSchedule.displayName = "GoogleSchedule";

export default GoogleSchedule;
